import { useEffect, useMemo, useState } from 'react';
import { ClientDailyBalance, getClientDailyBalance } from '@/services/client-daily-balance.service';
import { indexBalanceByDate } from './dayBalance';

export interface DayRange {
  dateFrom: string; // yyyy-MM-dd
  dateTo: string;   // yyyy-MM-dd
}

/**
 * Денний баланс клієнта за видимий проміжок календаря, за датою. Помилка або відсутність доступу - порожньо:
 * календар показується без підсумків.
 */
export function useClientDayBalance(
  clientId: string | number,
  range: DayRange | null,
  refreshKey: number,
): Record<string, ClientDailyBalance> {
  const [balances, setBalances] = useState<ClientDailyBalance[]>([]);
  const dateFrom = range?.dateFrom;
  const dateTo = range?.dateTo;

  useEffect(() => {
    if (!dateFrom || !dateTo) {
      setBalances([]);
      return;
    }
    let cancelled = false;
    getClientDailyBalance(clientId, dateFrom, dateTo)
      .then(data => { if (!cancelled) setBalances(data); })
      .catch(() => { if (!cancelled) setBalances([]); });
    return () => { cancelled = true; };
  }, [clientId, dateFrom, dateTo, refreshKey]);

  return useMemo(() => indexBalanceByDate(balances), [balances]);
}
